/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useContext, useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import { LayoutContext } from "../../components/layout";
import isEmpty from "lodash/isEmpty";
import { getEsignStatements } from "../../services/filterHelper";
import reportStatement from "../../assets/reportStatements.json";
import { Checkbox } from "./Checkbox";
import { CsCheckbox } from "./CsCheckbox";
import { DebounceInput } from "react-debounce-input";
import fetchHelper from "../../services/fetchHelper";

export function Statements({ showAll, show, setShow, updatePrevReportStatements }) {
  const { headerDetails: userInfo } = useContext(LayoutContext);
  const [textSearch, setTextSearch] = useState("");
  const [filteredCstIdList, setFilteredCstIdList] = useState([]);
  const [interrogationStats, setInterrogationStats] = useState([]);
  const { addToast } = useToasts();

  useEffect(() => {
    if (!isEmpty(textSearch)) {
      setShow(true);
    }
    setFilteredCstIdList(getEsignStatements(textSearch));
  }, [textSearch]);

  useEffect(() => {
    if (userInfo && !userInfo.isCst) {
      getInterrogationStats();
    }
  }, [userInfo]);

  const getInterrogationStats = async () => {
    try {
      const url = encodeURI(
        `/patientmanagement/rest/interrogationstatement?where={"interrogation.id":{"$eq":${userInfo.id}}}`
      );
      const res = await fetch(url, {
        headers: fetchHelper.getSecurityHeader(),
      });
      if (res.ok) {
        const stat = await res.json();
        setInterrogationStats(stat);
      }
    } catch (error) {
      addToast("An error occurred while obtaining the interrogation statements, please try later.", {
        appearance: "error",
        autoDismiss: false,
      });
    }
  };

  const checkboxList = () => {
    if (userInfo.isCst) {
      return reportStatement.map((rs, index) => {
        return (
          <Checkbox
            data={rs}
            filteredCstIdList={filteredCstIdList}
            hasSearched={!isEmpty(textSearch)}
            globalShow={show}
            key={`checkbox-${index}`}
            updateStatements={updatePrevReportStatements}
          />
        );
      });
    }
    return interrogationStats.map((is, index) => {
      return (
        <CsCheckbox
          data={is}
          interrogationStats={interrogationStats}
          setInterrogationStats={setInterrogationStats}
          globalShow={show}
          key={`checkbox-${index}`}
        />
      );
    });
  };

  return (
    <fieldset id="discrete-statements-section">
      <div className="grp-hdr">
        <button
          className="btn btn-sm btn-hide-section "
          onClick={showAll}
          disabled={!isEmpty(textSearch)}
          type="button"
          id="show-hide-btn"
        >
          <i className="ti ti-eye" />
          <strong>{show ? "Hide" : "Show"}</strong>
        </button>
        <h3 id="statements-header">Statements</h3>
      </div>
      {userInfo.isCst && (
        <div>
          <DebounceInput
            debounceTimeout={800}
            type="text"
            placeholder="Search..."
            onChange={(event) => setTextSearch(event.target.value)}
            className="searchDiscrete"
            id="statements-search"
          />
        </div>
      )}
      {checkboxList()}
    </fieldset>
  );
}
